<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Pending Payment Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Pending Payment Details",
            items: [
               {
                  text: "Pending Payments",
                  href: "/doctor-payments/pending",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            pending: {},
            consultations: [],
            selectedConsultations: [],
            selectedConsultationsList: [],
            basket_amount_paid: 0,
            basket_commision : 0,
            basket_total : 0,


            
            payment: {
               amount: '',
               payment_id: '',
               payment_notes: '',
               doctor_id: '',
               booking_ids: [],
            },

            image: '',
            preview_image: '',

            token: '',
            errors: {},
            
            loading: false,

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchDetails();
      },


      methods: {

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchDetails() {
            let url = "api/admin/doctor/payments/pending_details?doctor_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.pending = responseData.pending_payment;  
               this.consultations = responseData.consultations;

               this.payment.amount = this.pending.amount_to_be_paid;
               this.payment.doctor_id = this.pending.doctor_id;

               this.payment.booking_ids = [];
               for(var i=0; i< this.consultations.length; i++) {
                  this.payment.booking_ids.push(this.consultations[i].booking_id)
                  // this.selectedConsultations.push(this.consultations[i].booking_id)

               }
               this.selectedConsultationsList = responseData.consultations;

               this.calculateTotals();

               console.log(this.payment.booking_ids);


            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         calculateTotals() {
            let basket_total = 0;
            let basket_commision = 0;
            let basket_amount_paid = 0;
            this.selectedConsultations = [];

            this.selectedConsultationsList.forEach(val => {
               if(val.total_amount){
                  basket_total += Number(val.total_amount);
               }
               if(val.commision){
                  basket_commision += Number(val.commision);
               }
               this.selectedConsultations.push(val.booking_id);

            });
            console.log('test');
            console.log(this.selectedConsultations);
            basket_amount_paid = basket_total - basket_commision;
            this.basket_total = basket_total;
            this.basket_commision = basket_commision;
            this.basket_amount_paid = basket_amount_paid;

            console.log(basket_total);
            console.log(basket_commision);
            console.log(basket_amount_paid);
         },


         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },    

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         }, 

         check() {
            console.log(this.selectedConsultations.length);
            if(this.selectedConsultations.length>0){
               this.showModal('payment-modal');
            }else{
               this.$swal("", "Please choose consultations", "error");
            }
         }, 
         addPayment() {
            this.getToken();
            this.loading = true;
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/doctor/payments/add";             
       
            let formData = new FormData();
            formData.append("doctor_id", this.payment.doctor_id); 
            formData.append("payment_id", this.payment.payment_id); 
            formData.append("payment_notes", this.payment.payment_notes); 
            formData.append('payment_image', this.image)  ;

            formData.append('booking_ids', JSON.stringify(this.selectedConsultations));
            formData.append('payment', this.image)  ;            

           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: 'payments.completed'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
         handleSelection() {
            this.calculateTotals();
         },

         clearForm() {
            this.payment.payment_notes = '';
            this.payment.payment_id = '';            
            this.image = '';
            this.preview_image = '';
            this.errors = {};
         }
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <router-link :to="{ name: 'payments.pending' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">                        
                        <b-card header-class="bg-transparent border-light" class="border border-light">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Pending Amount Details</h4>                         
                           <b-row>
                              <b-col md="12">
                                 <h5>Doctor</h5>
                                 <p>Dr. {{pending.name}}<br>
                                    {{pending.country_code}} {{pending.mobile}}
                                 </p>

                                 <h5>Total Amount</h5>
                                 <p>Rs. {{basket_total}}</p>

                                 <h5>Commission</h5>
                                 <p>Rs. {{basket_commision}}</p>

                                 <h5>Amount to be Paid</h5>
                                 <p>Rs. {{basket_amount_paid}}</p>
                              </b-col>    
                           </b-row>
                           <!-- <b-button v-b-modal.payment-modal variant="primary" class="btn-sm mt-2 mr-1">Add Payment</b-button> -->
                           <b-button @click="check" variant="primary" class="btn-sm mt-2 mr-1">Add Payment</b-button>
                        </b-card>
                     </div>

                     <div class="col-lg-7 col-md-7">
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Consultations</h4>
                     <b-row>
                        <b-col lg="6" class="payment-consultation" v-for="consultation in consultations" :key="consultation.booking_id">
                       
                           <div class="d-flex align-items-center justify-content-between">
                           <h5 class="mb-0">Booking ID: {{ consultation.booking_id }}</h5>
                           <b-form-checkbox 
                              v-model="selectedConsultationsList"  
                              :value="consultation" @change="handleSelection"
                              class="mb-0"
                           >
                           </b-form-checkbox>
                           </div>
                          
                        <p>{{ consultation.booking_date | formatDate }}, {{ consultation.consultation_start | formatTime }} - {{ consultation.consultation_end | formatTime }}<br>
                           Amount to be Paid - Rs. {{ consultation.amount_to_be_paid }}</p>
                        </b-col>  
                     </b-row>
                  </b-card>
                  <!-- end card -->                      
                  </div>

                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="payment-modal" id="payment-modal" title="Payment" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="addPayment()">
                                       
            <b-col md="12" class="form-group">
               <label class="control-label">Amount (in Rs)<span class="text-danger">*</span></label>
               <input type="text" v-model="basket_amount_paid" class="form-control" disabled>

            </b-col>  

            <b-col md="12" class="form-group">
               <label class="control-label">Payment ID<span class="text-danger">*</span></label>
               <input type="text" v-model="payment.payment_id" class="form-control" :class="{ 'is-invalid': Boolean(errors.payment_id) }">

               <div v-for="(val, index) in errors.payment_id" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-col>  

            <b-col md="12" class="form-group">
               <label class="control-label">Payment Image</label>
                           
               <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.payment_image) }" />

               <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-col>    

            <b-col md="12" class="form-group">
               <label class="control-label">Payment Notes</label>
               <textarea class="form-control" v-model="payment.payment_notes" rows="3" :class="{ 'is-invalid': Boolean(errors.payment_image) }"></textarea>

               <div v-for="(val, index) in errors.payment_notes" :key="index" class="invalid-feedback">
                  <p class="mb-0">{{ val }}</p>
               </div>
            </b-col>                       
                                        
            <b-col md="12">
               <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ loading ? 'Saving...' : 'Save' }}
               </b-button>
               <b-button class="" variant="light" @click="hideModal('payment-modal')" :disabled="loading">Close</b-button>
            </b-col>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
